import script from "./SectionProjectsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionProjectsOverview.vue?vue&type=script&setup=true&lang=js"

import "./SectionProjectsOverview.vue?vue&type=style&index=0&id=c9b4f1d6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9b4f1d6"]])

export default __exports__